import { useState } from "react";
import { useToastContext } from "../../../contexts/ToastContext/ToastContext";
import { redirectIfUnauthorized } from "../utils/adminUtils";
import { getErrorCode } from "./useAdminList";

// Executa uma ação sobre um item (processar, autorizar...) e controla qual item está em andamento
const useAdminAction = () => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [runningId, setRunningId] = useState(null);

  const run = async (id, action, successDetail) => {
    setRunningId(id);
    try {
      await action();
      if (successDetail) showSuccessToast({ detail: successDetail });
      return true;
    } catch (e) {
      if (redirectIfUnauthorized(e)) return false;
      console.log(e);
      showErrorToast({ code: getErrorCode(e) });
      return false;
    } finally {
      setRunningId(null);
    }
  };

  return { run, runningId };
};

export default useAdminAction;
